<template>
  <div class="party-affairs">
    <div
      class="public-list-template"
      v-for="data in datas"
      :key="data.id"
      @click="goDetail(data.id)"
    >
      <div class="news-left">
        <img :src="data.imgurl" alt v-if="data.imgurl==null?false:true" />
      </div>
      <div class="news-right">
        <p>{{data.headline}}</p>
        <p>
          <!-- <span style="margin-right:.5rem;">浏览:{{data.sees}}</span>
          <span>点赞:{{data.praise}}</span> -->
          <span style="float:right;margin-right:.3rem">{{data.createtime|times}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getActiList } from '@/api/partyHomeApi.js'

export default {
  data() {
    return {
      datas: [],
    };
  },

  mounted: function() {
    this.render();
  },
  methods: {
    active(index, name) {
      this.isClass = index;
    },
    render() {
      const params = {
        headline:this.$route.query.title,
        post:sessionStorage.getItem('token')
      }
      getActiList(params).then(res => {
        const { msg } = res
        this.datas = msg || []
      })
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: newsid, dbnum: 2 }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.party-affairs {
  .public-list-template {
    font-size: 0.3rem;
    width: 94%;
    margin: 0 auto;
    display: flex;
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.2rem 0;
    //   align-items: center;
    .news-right {
      width: 100%;
      margin-left: 0.2rem;
      p:nth-child(1) {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        margin-bottom: 0.3rem;
        line-height: 1.8;
      }
      p:nth-child(2) {
        border-top: 0.01rem solid #e6e6e6;
        padding-top: 0.2rem;
        color: #999999;
        font-size: 0.26rem;
      }
    }
    .news-left {
      img {
        width: 2.4rem;
        height: 2rem;
      }
    }
  }
  .choose-state {
    .choose {
      color: #000;
      position: relative;
      &::before {
        position: absolute;
        width: 25%;
        height: 0.08rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#ae1717, #ae1717);
        border-radius: 0.1rem;
        left: 37.5%;
        content: "";
        bottom: 0;
      }
    }
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
      line-height: 3;
      color: #999999;
    }
    background: #fff;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>

